export default __webpack_public_path__ + "static/media/Dhana Jewellery Mart.a935b7ec.jpg";